// NavigationFooter.js
import React from 'react';

const NavigationFooter = ({ 
  currentIndex, 
  contacts, 
  hasNext, 
  hasPrevious, 
  onNavigate,
  isLead = false 
}) => {
  return (
    <div className="px-6 py-4 border-t bg-white flex justify-between items-center sticky bottom-0 shadow-inner rounded-bl-3xl">
      <div className="flex gap-3">
        <button
          onClick={() => onNavigate('previous')}
          disabled={!hasPrevious}
          className={`flex items-center px-4 py-2 rounded-md transition-all duration-200 ${
            hasPrevious 
              ? 'bg-white border border-[#3985b6] text-[#3985b6] hover:bg-[#f0f7fc]' 
              : 'bg-gray-100 text-gray-400 cursor-not-allowed border border-gray-200'
          }`}
        >
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-1" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
          </svg>
          Previous
        </button>
        <button
          onClick={() => onNavigate('next')}
          disabled={!hasNext}
          className={`flex items-center px-4 py-2 rounded-md transition-all duration-200 ${
            hasNext 
              ? 'bg-white border border-[#3985b6] text-[#3985b6] hover:bg-[#f0f7fc]' 
              : 'bg-gray-100 text-gray-400 cursor-not-allowed border border-gray-200'
          }`}
        >
          Next
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-1" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </button>
      </div>
      
      <div>
        <span className="text-gray-600 font-medium">
          {currentIndex + 1} of {contacts.length} {isLead ? 'Leads' : 'Contacts'}
        </span>
      </div>
    </div>
  );
};

export default NavigationFooter;
